import {
  CubeTransparentIcon,
  ClipboardDocumentIcon,
  CursorArrowRaysIcon,
  ListBulletIcon,
  FolderIcon,
  ChartBarIcon,
  BellAlertIcon,
  BuildingOfficeIcon,
  ExclamationTriangleIcon,
  UserGroupIcon,
  ArchiveBoxIcon,
  PresentationChartBarIcon,
  AtSymbolIcon,
  TruckIcon,
  NewspaperIcon,
  PaperClipIcon,
  DocumentIcon,
  ClockIcon,
  CogIcon,
  UserIcon,
  TableCellsIcon,
  ArrowsPointingOutIcon,
  ScaleIcon,
  ArrowDownOnSquareIcon,
  ArrowUpOnSquareIcon,
  PowerIcon,
  MapIcon,
  TagIcon,
  PhotoIcon,
  BanknotesIcon,
  EnvelopeIcon,
  MegaphoneIcon,
  DocumentCheckIcon,
//  UserCircleIcon,
  MinusIcon,
  DocumentMagnifyingGlassIcon,
  TrashIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { Accordion, AccordionItem, Avatar } from "@nextui-org/react";
import logo from "../../../assets/images/logo_klhk.png";
import ListItem from "../../elements/ListItem";
import { useEffect, useRef, useMemo } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import useSWR from "swr";
import { getFetcher } from "../../../services/api";
import {
  //ADMIN_REPORT_STORAGE,
  ASAL_MUAT_INDEX_PATH,
  CARBON_COPY_INDEX_PATH,
  CMS_ARTICLE_PATH,
  CMS_DOCUMENT_PATH,
  CMS_NEWS_PATH,
  COMPANY_INDEX_PATH,
  //COMPANY_REPORT_STORAGE,
  DASHBOARD_PATH,
  DASHBOARD_PERUSAHAAN_PATH,
  MATERIAL_INDEX_PATH,
  MERKURI_MONITORING_INDEX_PATH,
  NOTIFICATION_DASHBOARD_PATH,
  NOTIFICATION_INDEX_PATH,
  OFFICIAL_INDEX_PATH,
  PELAPORAN_DASHBOARD_PATH,
  PELAPORAN_PENGANGKUTAN_GRAFIK,
  PELAPORAN_PENGANGKUTAN_PENCARIAN,
  PELAPORAN_PENGGUNAAN_GRAFIK,
  PELAPORAN_PENGGUNAAN_PETA,
  PELAPORAN_PENGGUNAAN_PENCARIAN,
  PELAPORAN_PRODUSEN_GRAFIK,
  PELAPORAN_PRODUSEN_PETA,
  PELAPORAN_PRODUSEN_PENCARIAN,
  //PELAPORAN_PENYIMPANAN_GRAFIK_PATH,
  //PELAPORAN_PENYIMPANAN_MAPS_PATH,
  PERIOD_INDEX_PATH,
  RECOMENDATION_DASHBOARD_PATH,
  RECOMENDATION_INDEX_PATH,
  SEARCH_RECOMENDATION_PATH,
  REGISTRATION_DASHBOARD_PATH,
  REGISTRATION_INDEX_PATH,
  REPORT_CONSUMPTION_MATERIAL_INDEX,
  REPORT_DISTRIBUTION_MATERIAL_INDEX,
  REPORT_PRODUCTION_MATERIAL,
  STOK_B3_INDEX_ADMIN_PATH,
  STOK_B3_INDEX_USER_PATH,
  STOK_B3_RIWAYAT_PENGHAPUSAN_PATH,
  TUJUAN_BONGKAR_INDEX_PATH,
  USERS_MANAGEMENT_INDEX_PATH,
  WPR_INDEX_PATH,
  PELAPORAN_PENGANGKUTAN_MAPS,
  PELAPORAN_DITRIBUSI_GRAFIK_PATH,
  PELAPORAN_DISTRIBUI_MAPS_PATH,
  PELAPORAN_DISTRIBUI_PENCARIAN_PATH,
  PELAPORAN_IMPORT_GRAFIK_PATH,
  PELAPORAN_IMPORT_MAPS_PATH,
  PELAPORAN_IMPORT_PENCARIAN_PATH,
  CMS_CATEGORY_PATH,
  CMS_FAQ_PATH,
  CMS_GALLERY_PATH,
  CUSTOMER_INDEX_PATH,
  TRANSPORTER_INDEX_PATH,
  REPORT_PURCHASE_MATERIAL_INDEX,
  NOMOR_SURAT_MANAGEMENT_INDEX_PATH,
  TICKET_MANAGEMENT_INDEX_PATH,
  ANNOUNCEMENT_INDEX_PATH,
  MERKURI_MONITORING_BULK_PATH,
  PELABUHAN_BONGKAR_INDEX_PATH,
  SUPPLIER_INDEX_PATH,
  USER_RECOMENDATION_INDEX_PATH,
  SK_MANUAL_RECOMENDATION_PATH,
  COMPANY_REGISTRATION_INDEX_PATH,
  COMPANY_REGISTRATION_ADDSK_PATH,
  REVIEW_PELAPORAN_INDEX,
  USER_REVIEW_PELAPORAN_INDEX,
  REVIEW_NEW_USER,
  REPORT_TRANSPORT_RECOMENDATION_VEHICLE_INDEX,
  VEHICLE_INDEX_PATH,
  REGISTRATION_REKAP_PATH,
  VALIDATION_REGISTRATION_B3_PATH,
  TUGAS_SAYA_REGISTRASI_PATH,
  TUGAS_SAYA_REKOMENDASI_PATH,
  KOORDINATOR_DASHBOARD_PATH,
} from "../../../services/routes";
import useCustomNavigate from "../../../hooks/useCustomNavigate";
import RolesAccess from "../../../enums/roles";
import { BookOpenIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
//import { every } from "lodash";
import { hasValidRole } from "../../../services/helpers";

/*
 * Buku Manual Pelaporan Pengelolaan B3 - situs statis di public/panduan-pelaporan-b3,
 * ikut tersalin ke build/ saat npm run build. Dibuka di tab baru dengan muat ulang
 * penuh (tautan biasa, bukan NavLink), karena berkas itu bukan rute aplikasi.
 */
const URL_PANDUAN_PELAPORAN = `${process.env.PUBLIC_URL}/panduan-pelaporan-b3/index.html`;

export default function Sidebar({ isOpenSidebar, setIsOpenSidebar }) {
  const sidebarRef = useRef(null);
  const { user, roles } = useAuth();
  const { getCurrentRouteGroup } = useCustomNavigate();

  // Cek apakah user adalah Pengelola dan tidak punya perusahaan
  const isPengelolaWithoutCompany = useMemo(() => {
    const isPengelola = hasValidRole(roles, [RolesAccess.PENGELOLA]);
    const hasCompany = user?.companies && user.companies.length > 0;
    return isPengelola && !hasCompany;
  }, [roles, user]);

  // Hanya fetch untuk pengelola yang punya perusahaan
  const isPengelola = hasValidRole(roles, [RolesAccess.PENGELOLA]);
  const companyIds = user?.companies?.map((c) => c.companyId).join(",");

  // Hit API untuk mendapatkan data company lengkap dengan tipePerusahaan
  const { data: companiesData } = useSWR(isPengelola && companyIds ? `/api/company/search-company?companyIds=${companyIds}&returnAll=true` : null, getFetcher);

  // Dapatkan semua tipe perusahaan yang dimiliki pengelola dari API
  const userCompanyTypes = useMemo(() => {
    if (!companiesData?.data || companiesData.data.length === 0) return [];

    // Kumpulkan semua tipe perusahaan dari semua perusahaan user
    const allTypes = new Set();
    companiesData.data.forEach((company) => {
      if (company.tipePerusahaan && Array.isArray(company.tipePerusahaan)) {
        company.tipePerusahaan.forEach((type) => allTypes.add(type));
      }
    });

    return Array.from(allTypes);
  }, [companiesData]);

  // Data menu lengkap dengan assign roles
  const menuData = [
    {
      // Entri tingkat atas, bukan di dalam grup "Dasbor", karena grup itu
      // memang tidak terbuka untuk Pengelola sementara dasbor ini justru
      // dibuat untuk mereka.
      key: "dasbor-perusahaan",
      title: "Dasbor Perusahaan",
      url: DASHBOARD_PERUSAHAAN_PATH,
      icon: <PresentationChartBarIcon className="size-5" />,
      roles: [
        RolesAccess.SUPER_ADMIN,
        RolesAccess.PIC_PELAPORAN,
        RolesAccess.DIREKTUR,
        RolesAccess.KOORDINATOR,
        RolesAccess.PENGELOLA,
      ],
    },
    {
      key: "0",
      title: "Dasbor",
      icon: <CubeTransparentIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KAB_SUBDIT_REGISTRASI, RolesAccess.KAB_SUBDIT_REKOMENDASI, RolesAccess.PIC_PELAPORAN, RolesAccess.KOORDINATOR],
      children: [
        {
          title: "Dashboard Umum",
          url: DASHBOARD_PATH,
          icon: <ChartBarIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.KAB_SUBDIT_REGISTRASI, RolesAccess.DIREKTUR, RolesAccess.KAB_SUBDIT_REKOMENDASI],
        },
        {
          title: "Dashboard Koordinator",
          url: KOORDINATOR_DASHBOARD_PATH,
          icon: <ChartBarIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.KOORDINATOR],
        },
        {
          title: "Dashboard Pengangkutan",
          icon: <ChartBarIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
          children: [
            {
              title: "Grafik",
              url: PELAPORAN_PENGANGKUTAN_GRAFIK,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Peta",
              url: PELAPORAN_PENGANGKUTAN_MAPS,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Pencarian",
              url: PELAPORAN_PENGANGKUTAN_PENCARIAN,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
          ],
        },
        {
          title: "Dashboard Penggunaan",
          icon: <ChartBarIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
          children: [
            {
              title: "Grafik",
              url: PELAPORAN_PENGGUNAAN_GRAFIK,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Peta",
              url: PELAPORAN_PENGGUNAAN_PETA,
              icon: <MapIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Pencarian",
              url: PELAPORAN_PENGGUNAAN_PENCARIAN,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
          ],
        },
        {
          title: "Dashboard Produsen",
          icon: <ExclamationTriangleIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
          children: [
            {
              title: "Grafik",
              url: PELAPORAN_PRODUSEN_GRAFIK,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Peta",
              url: PELAPORAN_PRODUSEN_PETA,
              icon: <MapIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Pencarian",
              url: PELAPORAN_PRODUSEN_PENCARIAN,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
          ],
        },
        /*
        {
          title: "Dashboard Penyimpanan",
          icon: <ChartBarIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
          children: [
            {
              title: "Grafik",
              url: PELAPORAN_PENYIMPANAN_GRAFIK_PATH,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Peta",
              url: PELAPORAN_PENYIMPANAN_MAPS_PATH,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
          ],
        },
        */
        {
          title: "Dashboard Distribusi",
          icon: <ArrowsPointingOutIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
          children: [
            {
              title: "Grafik",
              url: PELAPORAN_DITRIBUSI_GRAFIK_PATH,
              icon: <ChartBarIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Peta",
              url: PELAPORAN_DISTRIBUI_MAPS_PATH,
              icon: <MapIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Pencarian",
              url: PELAPORAN_DISTRIBUI_PENCARIAN_PATH,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
          ],
        },
        {
          title: "Dashboard Import",
          icon: <ExclamationTriangleIcon className="size-5" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
          children: [
            {
              title: "Grafik",
              url: PELAPORAN_IMPORT_GRAFIK_PATH,
              icon: <ChartBarIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Peta",
              url: PELAPORAN_IMPORT_MAPS_PATH,
              icon: <MapIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
            {
              title: "Pencarian",
              url: PELAPORAN_IMPORT_PENCARIAN_PATH,
              icon: <ArchiveBoxIcon className="size-4" />,
              roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.DIREKTUR],
            },
          ],
        },
      ],
    },
    {
      key: "1",
      title: "Registrasi B3",
      icon: <ClipboardDocumentIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REGISTRASI, RolesAccess.DIREKTUR, RolesAccess.PENGELOLA, RolesAccess.KOORDINATOR],
      children: [
        {
          title: "Dasbor",
          url: REGISTRATION_DASHBOARD_PATH,
          icon: <ChartBarIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REGISTRASI, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR],
        },
        {
          title: "Tugas Saya",
          url: TUGAS_SAYA_REGISTRASI_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.PIC_REGISTRASI, RolesAccess.SUPER_ADMIN],
        },
        {
          title: "Daftar",
          url: REGISTRATION_INDEX_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR],
        },
        {
          title: "Daftar Saya",
          url: COMPANY_REGISTRATION_INDEX_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
        },
        {
          title: "Tambah SK Manual",
          url: COMPANY_REGISTRATION_ADDSK_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
          // SK Registrasi hanya relevan bagi pengimpor dan produsen B3.
          // Penyaring ini hanya berlaku bagi Pengelola; Super Admin tetap
          // melihat menunya untuk keperluan pendampingan.
          companyTypes: ["Impor B3", "Produksi B3"],
        },
        {
          title: "Rekapitulasi",
          url: REGISTRATION_REKAP_PATH,
          icon: <DocumentMagnifyingGlassIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR],
        },
        {
          title: "Pencarian Nomor Registrasi B3",
          url: VALIDATION_REGISTRATION_B3_PATH,
          icon: <DocumentMagnifyingGlassIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
        },
      ],
    },
    {
      key: "2",
      title: "Rekomendasi Pengangkutan B3",
      icon: <CursorArrowRaysIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.DIREKTUR, RolesAccess.PENGELOLA, RolesAccess.KOORDINATOR],
      children: [
        {
          title: "Dasbor",
          url: RECOMENDATION_DASHBOARD_PATH,
          icon: <ChartBarIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR],
        },
        {
          title: "Tugas Saya",
          url: TUGAS_SAYA_REKOMENDASI_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN],
        },
        {
          title: "Daftar",
          url: RECOMENDATION_INDEX_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR],
        },
        {
          title: "Daftar Saya",
          url: USER_RECOMENDATION_INDEX_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
        },
	{
          title: "Tambah SK Manual",
          url:   SK_MANUAL_RECOMENDATION_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
          // Rekomendasi pengangkutan hanya untuk perusahaan pengangkut B3.
          companyTypes: ["Mengangkut B3"],
        },
        {
          title: "Pencarian Pengangkut B3",
          url: SEARCH_RECOMENDATION_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
        },
      ],
    },
    {
      key: "3",
      title: "Pelaporan",
      icon: <PresentationChartBarIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA],
      children: [
        {
          title: "Dashboard",
          url: PELAPORAN_DASHBOARD_PATH,
          icon: <TableCellsIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA],
          companyTypes: [], // Semua tipe bisa akses
        },
        {
          title: "Review Pelaporan Perusahaan",
          url: USER_REVIEW_PELAPORAN_INDEX,
          icon: <DocumentCheckIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA],
          companyTypes: [], // Semua tipe bisa akses
        },
        /*
        {
          title: "Review Penyimpanan B3",
          url: ADMIN_REPORT_STORAGE,
          icon: <ArchiveBoxIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN],
        },
        */
        {
          title: "Review Pelaporan Pengelolaan dan Pengangkutan B3",
          url: REVIEW_PELAPORAN_INDEX,
          icon: <DocumentCheckIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN],
        },

        // Akses untuk Pengelola (User) - Filtered by Company Types
        /*
        {
          title: "Penyimpanan B3",
          url: COMPANY_REPORT_STORAGE,
          icon: <ArchiveBoxIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
          companyTypes: [], // Semua tipe bisa akses
        },
        */
        {
          title: "Pengangkutan B3",
          url: REPORT_TRANSPORT_RECOMENDATION_VEHICLE_INDEX,
          icon: <TruckIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
          companyTypes: ["Mengangkut B3"], // Hanya untuk tipe Mengangkut B3
        },
        {
          title: "Produksi B3",
          url: REPORT_PRODUCTION_MATERIAL,
          icon: <ExclamationTriangleIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
          companyTypes: ["Produksi B3"], // Hanya untuk tipe Produksi B3
        },
        {
          title: "Distribusi B3",
          url: REPORT_DISTRIBUTION_MATERIAL_INDEX,
          icon: <ArrowsPointingOutIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
          companyTypes: ["Distribusi B3"], // Hanya untuk tipe Distribusi B3
        },
        {
          title: "Penggunaan B3",
          url: REPORT_CONSUMPTION_MATERIAL_INDEX,
          icon: <ScaleIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
          companyTypes: ["Menggunakan B3", "Produksi B3"], // Untuk tipe Menggunakan B3 dan Produksi B3
        },
        {
          title: "Pembelian B3",
          url: REPORT_PURCHASE_MATERIAL_INDEX,
          icon: <BanknotesIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
          companyTypes: ["Impor B3", "Distribusi B3", "Menggunakan B3"], // Untuk tipe Impor B3, Distribusi B3, dan Menggunakan B3
        },
      ],
    },
    /*
    {
      key: "4",
      title: "Notifikasi",
      icon: <BellAlertIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.DIREKTUR, RolesAccess.PENGELOLA],
      children: [
        {
          title: "Dasbor",
          url: NOTIFICATION_DASHBOARD_PATH,
          icon: <ChartBarIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.DIREKTUR],
        },
        {
          title: "Daftar",
          url: NOTIFICATION_INDEX_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PENGELOLA],
        },
      ],
    },
    */
    {
      key: "5",
      title: "Data Master",
      icon: <FolderIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.PENGELOLA, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI], // Akses hanya untuk SuperAdmin
      children: [
        {
          title: "Tembusan",
          url: CARBON_COPY_INDEX_PATH,
          icon: <AtSymbolIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Pejabat",
          url: OFFICIAL_INDEX_PATH,
          icon: <UserGroupIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Bahan B3",
          url: MATERIAL_INDEX_PATH,
          icon: <ExclamationTriangleIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Perusahaan",
          url: COMPANY_INDEX_PATH,
          icon: <BuildingOfficeIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Kendaraan",
          url: VEHICLE_INDEX_PATH,
          icon: <TruckIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REKOMENDASI],
        },
        {
          title: "Periode",
          url: PERIOD_INDEX_PATH,
          icon: <ClockIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Perusahaan Asal Muat",
          url: ASAL_MUAT_INDEX_PATH,
          icon: <ArrowDownOnSquareIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Nomor Surat",
          url: NOMOR_SURAT_MANAGEMENT_INDEX_PATH,
          icon: <ArchiveBoxIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_NOTIFIKASI], // Akses hanya untuk SuperAdmin
        },
        {
          title: "Perusahaan Tujuan Bongkar",
          url: TUJUAN_BONGKAR_INDEX_PATH,
          icon: <ArrowUpOnSquareIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI],
        },
        {
          title: "Perusahaan Customer",
          url: CUSTOMER_INDEX_PATH,
          icon: <UserIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
        },
        {
          title: "Perusahaan Transporter",
          url: TRANSPORTER_INDEX_PATH,
          icon: <UserIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
        },
        {
          title: "Perusahaan Supplier",
          url: SUPPLIER_INDEX_PATH,
          icon: <UserIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
        },
        {
          title: "Pelabuhan Bongkar",
          url: PELABUHAN_BONGKAR_INDEX_PATH,
          icon: <UserIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN],
        },
      ],
    },
    {
      key: "6",
      title: "CMS",
      icon: <NewspaperIcon className="size-4" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
      children: [
        {
          title: "Berita",
          url: CMS_NEWS_PATH,
          icon: <NewspaperIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
        },
        {
          title: "Artikel",
          url: CMS_ARTICLE_PATH,
          icon: <PaperClipIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
        },
        {
          title: "Dokumen",
          url: CMS_DOCUMENT_PATH,
          icon: <DocumentIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
        },
        {
          title: "Gallery",
          url: CMS_GALLERY_PATH,
          icon: <PhotoIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
        },
        {
          title: "FAQ",
          url: CMS_FAQ_PATH,
          icon: <QuestionMarkCircleIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
        },
        {
          title: "Category",
          url: CMS_CATEGORY_PATH,
          icon: <TagIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS],
        },
      ],
    },
    {
      key: "7",
      title: "Stok B3",
      icon: <BellAlertIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN],
      children: [
        {
          title: "Stok B3 Admin",
          url: STOK_B3_INDEX_ADMIN_PATH,
          icon: <ChartBarIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN],
        },
        {
          title: "Stok B3 User",
          url: STOK_B3_INDEX_USER_PATH,
          icon: <ListBulletIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA],
        },
        {
          title: "Riwayat Penghapusan Stok",
          url: STOK_B3_RIWAYAT_PENGHAPUSAN_PATH,
          icon: <TrashIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN],
        },
      ],
    },
    {
      key: "8",
      title: "Merkuri",
      icon: <PowerIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS, RolesAccess.DIREKTUR], // Akses untuk SuperAdmin dan Pengelola
      children: [
        {
          title: "Wilayah Pertambangan Rakyat",
          url: WPR_INDEX_PATH,
          icon: <CogIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS], // Hanya untuk SuperAdmin
        },
        {
          title: "Merkuri Monitoring Lingkungan",
          url: MERKURI_MONITORING_INDEX_PATH,
          icon: <ArchiveBoxIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS], // Hanya untuk SuperAdmin
        },
        {
          title: "Bulk Merkuri Monitoring Lingkungan",
          url: MERKURI_MONITORING_BULK_PATH,
          icon: <TagIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_CMS], // Hanya untuk SuperAdmin
        },
      ],
    },
    {
      key: "9",
      title: "User Management",
      url: USERS_MANAGEMENT_INDEX_PATH,
      icon: <UserGroupIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_USER],
      children: [
        {
          title: "Daftar User",
          url: USERS_MANAGEMENT_INDEX_PATH,
          icon: <MinusIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_USER], // Hanya untuk SuperAdmin
        },
        {
          title: "Review User",
          url: REVIEW_NEW_USER,
          icon: <MinusIcon className="size-4" />,
          roles: [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_USER], // Hanya untuk SuperAdmin
        },
      ],
    },
    {
      key: "10",
      title: "Konsultasi",
      url: TICKET_MANAGEMENT_INDEX_PATH,
      icon: <EnvelopeIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.PIC_KONSULTASI, RolesAccess.PENGELOLA],
    },
    {
      key: "11",
      title: "Pengumuman",
      url: ANNOUNCEMENT_INDEX_PATH,
      icon: <MegaphoneIcon className="size-5" />,
      roles: [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.PIC_KONSULTASI],
    },
  ];

  /*
  const itemClasses = {
    base: "w-full",
    startContent: "text-primary",
    title: "text-small text-primary",
    indicator: "text-primary",
    content: "py-0",
    trigger: "px-4 py-3 data-[hover=true]:bg-primary/20 flex items-center data-[open=true]:bg-primary/20",
  };
  */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpenSidebar(false);
      }
    };

    if (isOpenSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenSidebar, setIsOpenSidebar, sidebarRef]);

  // Drawer: Escape menutup, fokus masuk panel saat dibuka dan kembali ke tombol
  // pemicu saat ditutup (checklist aksesibilitas design system, temuan A3-01/A3-03).
  useEffect(() => {
    if (!isOpenSidebar) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpenSidebar(false);
    };

    document.addEventListener("keydown", handleKeyDown);

    // Fokus baru dipindahkan setelah transisi panel selesai. Memanggil focus()
    // segera tidak bertahan: NextUI/react-aria mengembalikan fokus ke tombol
    // pemicu setelah event klik selesai.
    const panel = sidebarRef.current;
    const focusPanel = () => {
      if (!panel || document.activeElement === panel) return;
      panel.focus();
    };

    // transitionend menggelembung dari elemen anak (item nav punya
    // transition-colors). Kalau tidak disaring, handler ini terpicu saat panel
    // masih visibility:hidden sehingga focus() gagal diam-diam.
    const handleTransitionEnd = (event) => {
      if (event.target !== panel) return;
      focusPanel();
    };

    panel?.addEventListener("transitionend", handleTransitionEnd);
    const focusTimer = setTimeout(focusPanel, 350);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      panel?.removeEventListener("transitionend", handleTransitionEnd);
      clearTimeout(focusTimer);
      document.getElementById("sidebar-toggle")?.focus();
    };
  }, [isOpenSidebar, setIsOpenSidebar]);

  const filterMenuByRoles = (menuList, roles) => {
    /*
     * Penyaring tipe perusahaan hanya berlaku bagi Pengelola. Super Admin
     * disebut terpisah - bukan sekadar mengandalkan "bukan Pengelola" - sebab
     * ada akun yang memegang dua peran sekaligus, dan akun seperti itu tetap
     * harus melihat seluruh menu.
     */
    const superAdmin = hasValidRole(roles, [RolesAccess.SUPER_ADMIN]);
    const isPengelola = !superAdmin && hasValidRole(roles, [RolesAccess.PENGELOLA]);

    return menuList
      .filter((menu) => {
        // Check role access
        const hasRole = menu?.roles?.some((role) => roles.includes(role));
        if (!hasRole) return false;

        // Jika menu punya companyTypes requirement dan user adalah pengelola
        if (isPengelola && menu.companyTypes !== undefined) {
          // Jika companyTypes kosong, artinya semua tipe bisa akses
          if (menu.companyTypes.length === 0) return true;

          // Jika user tidak punya perusahaan atau tidak punya tipe yang sesuai
          if (userCompanyTypes.length === 0) return false;

          // Check apakah user punya salah satu tipe perusahaan yang diperlukan
          const hasRequiredType = menu.companyTypes.some((type) => userCompanyTypes.includes(type));
          return hasRequiredType;
        }

        return true;
      })
      .map((menu) => {
        if (menu.children) {
          const filteredChildren = filterMenuByRoles(menu.children, roles);
          return {
            ...menu,
            children: filteredChildren,
          };
        }
        return menu;
      })
      .filter((menu) => {
        const hasValidChildren = !menu.children || menu.children.length > 0;
        return hasValidChildren;
      });
  };

  // Filter menu berdasarkan roles dan tipe perusahaan
  const filteredMenu = useMemo(() => {
    return filterMenuByRoles(menuData, roles);
  }, 
    // eslint-disable-next-line
    [roles, userCompanyTypes]
  );

  // Fungsi untuk mengecek apakah menu item harus di-disable
  const isMenuDisabled = (menu) => {
    if (!isPengelolaWithoutCompany) return false;

    // Allow Data Master (key=5) dan menu Perusahaan
    if (menu.key === "5") return false;
    if (menu.url === COMPANY_INDEX_PATH) return false;

    // Disable semua menu lainnya
    return true;
  };

  const renderMenuItems = (menuList, level = 1) => {
    return menuList.map((menu) => {
      const disabled = isMenuDisabled(menu);

      if (menu.children && menu.children.length > 0) {
        // Cek apakah ada children yang tidak disabled
        const hasEnabledChildren = menu.children.some((child) => !isMenuDisabled(child));

        return (
          <Accordion
            key={menu.key}
            showDivider={false}
            className={`px-0`}
            isDisabled={disabled && !hasEnabledChildren}
            itemClasses={{
              base: "w-full",
              startContent: disabled && !hasEnabledChildren ? "text-white/35" : "text-white/80",
              title: disabled && !hasEnabledChildren ? "text-small text-white/35" : "text-small text-white/80",
              indicator: disabled && !hasEnabledChildren ? "text-white/35" : "text-white/60",
              content: "py-0",
              trigger: `pr-3 ${level === 1 ? "pl-3" : "pl-8"} py-2.5 min-h-[44px] rounded-ds-sm flex items-center data-[hover=true]:bg-white/10 data-[open=true]:bg-white/10`,
            }}
            defaultSelectedKeys={getCurrentRouteGroup()}
          >
            <AccordionItem key={menu.key} title={menu.title} startContent={<div className={disabled && !hasEnabledChildren ? "opacity-50" : ""}>{menu.icon}</div>}>
              {renderMenuItems(menu.children, level + 1)}
            </AccordionItem>
          </Accordion>
        );
      }
      return (
        <ListItem
          key={menu.key}
          url={menu.url}
          title={menu.title}
          icon={menu.icon}
          isDisabled={disabled}
          className={level === 1 ? "pl-4" : level === 2 ? "pl-8" : "pl-12"} // Indentasi sesuai level
        />
      );
    });
  };

  return (
    <>
      {/* Scrim drawer — DS: dapat diklik untuk menutup, hanya di bawah 1024px */}
      <div
        aria-hidden="true"
        onClick={() => setIsOpenSidebar(false)}
        className={`fixed inset-0 z-40 bg-ink-900/50 transition-opacity duration-300 lg:hidden ${
          isOpenSidebar ? "visible opacity-100" : "invisible opacity-0"
        }`}
      />

      {/* App Shell T5 — sidebar 264px, latar --g-800. Di bawah 1024px menjadi
          drawer off-canvas; `visibility` ikut transisi agar tautan yang
          tersembunyi tidak bisa menerima fokus keyboard. */}
      <aside
        id="logo-sidebar"
        ref={sidebarRef}
        tabIndex={-1}
        aria-label="Sidebar"
        className={`fixed top-0 left-0 z-50 w-sidebar h-screen bg-g-800 text-white shadow-ds-3 transition-[transform,visibility] duration-300 outline-none ${
          isOpenSidebar ? "visible translate-x-0" : "invisible -translate-x-full"
        } lg:visible lg:translate-x-0`}
      >
        <div className="h-full overflow-y-auto">
          <div className="px-3 py-4 flex items-center gap-[10px] border-b border-white/[0.12]">
            <Avatar src={logo} className="w-[34px] h-[34px] shrink-0 bg-white p-0.5" />
            <div className="flex flex-col leading-tight">
              <span className="font-display text-[13px] font-bold uppercase">Direktorat Pengelolaan B3</span>
              <span className="text-[10px] uppercase text-white/70">Kementerian Lingkungan Hidup</span>
            </div>
          </div>

          {/* Peringatan untuk Pengelola tanpa perusahaan */}
          {isPengelolaWithoutCompany && (
            <div className="mx-3 mt-4 p-3 bg-white/10 border border-white/20 rounded-ds-sm">
              <p className="text-xs text-o-300 font-semibold mb-1">⚠️ Akun Belum Terhubung</p>
              <p className="text-xs text-white/80">Silakan hubungkan akun Anda dengan perusahaan di menu Data Master → Perusahaan untuk mengakses fitur lengkap.</p>
            </div>
          )}

          {/* Informasi tipe perusahaan untuk pengelola */}
          {hasValidRole(roles, [RolesAccess.PENGELOLA]) && userCompanyTypes.length > 0 && (
            <div className="mx-3 mt-4 p-3 bg-white/10 border border-white/20 rounded-ds-sm">
              <p className="text-xs text-b-300 font-semibold mb-1">ℹ️ Tipe Perusahaan Anda</p>
              <div className="flex flex-wrap gap-1 mt-2">
                {userCompanyTypes.map((type, index) => (
                  <span key={index.id || index} className="text-xs bg-white/15 text-white px-2 py-0.5 rounded-ds-xs">
                    {type === "Impor B3" ? "Pembelian B3" : type}
                  </span>
                ))}
              </div>
            </div>
          )}

          <ul className="flex flex-col gap-0.5 px-3 py-3">
            {renderMenuItems(filteredMenu)}
            {/* Untuk SEMUA pengguna, selalu paling bawah, dan tidak ikut dinonaktifkan
                bagi Pengelola yang belum terhubung ke perusahaan. */}
            <li>
              <a
                href={URL_PANDUAN_PELAPORAN}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-[11px] min-h-[44px] px-3 py-2.5 pl-4 rounded-ds-sm text-[13.5px] font-medium transition-colors text-white/80 hover:bg-white/10 hover:text-white"
              >
                <div className="flex-shrink-0"><BookOpenIcon className="size-5" /></div>
                <span className="flex-1">Panduan Pelaporan B3</span>
                <ArrowTopRightOnSquareIcon className="size-4 flex-shrink-0" aria-hidden="true" />
                <span className="sr-only">(membuka tab baru)</span>
              </a>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
}

